import { useLayoutEffect } from 'react';
import { Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StoreLayout } from '@/StoreLayout';
import { DEFAULT_LANG, LANGS, LocaleContext } from '@/lib/locale';

// Sets the UI language for everything under one URL prefix.
export const LocaleScope = ({ lang, children }) => {
  const { i18n } = useTranslation();
  useLayoutEffect(() => {
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
  }, [lang, i18n]);
  return <LocaleContext.Provider value={lang}>{children}</LocaleContext.Provider>;
};

// The storefront once per language: /ru/*, /it/*, then English at the root.
// Shared by App.js and the prerender entry (src/ssr/render.js).
export const storeRoutes = (props) => [
  ...LANGS.filter((l) => l !== DEFAULT_LANG).map((lang) => (
    <Route
      key={lang}
      path={`/${lang}/*`}
      element={
        <LocaleScope lang={lang}>
          <StoreLayout {...props} />
        </LocaleScope>
      }
    />
  )),
  <Route
    key={DEFAULT_LANG}
    path="/*"
    element={
      <LocaleScope lang={DEFAULT_LANG}>
        <StoreLayout {...props} />
      </LocaleScope>
    }
  />,
];
